window.onerror = myErrHandler;
var errorReportet = false;
function myErrHandler(message, url, line) {
    //alert(message);
    try {
        if (!errorReportet) {
            $.ajax({
                cache: false,
                type: "post",
                data: {
                    ErrorMessage: message,
                    Url: url,
                    Line: line,
                    Browser: navigator.userAgent
                },
                url: ajaxUrls.logging.index,
                async: true
            });
        }
        errorReportet = true;
        return false;
    } catch (e) {

    }
    return false;
}
